import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IBadge } from '@clickersphere/core/entities/IBadge';
import BadgeService from '@clickersphere/core/services/BadgeService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const BADGES_QUERY_KEY = 'badges';

export type BadgeQueryData = WithQueryStatus<IBadge>;

export function useBadges() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: badges,
    isSuccess: isBadgesSuccess,
    isFetching: isBadgesFetching,
    isLoading: isBadgesLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(BADGES_QUERY_KEY),
    queryFn: async () => {
      const result = await BadgeService.getAll();
      return result as BadgeQueryData[];
    },
    select: (data) =>
      [...data].sort((a, b) => {
        if (a.usageCount !== b.usageCount) {
          return b.usageCount - a.usageCount;
        }
        return a.name.localeCompare(b.name);
      }),
  });

  return {
    badges: badges ?? [],
    isBadgesSuccess,
    isBadgesFetching,
    isBadgesLoading,
  };
}
